module.exports = __webpack_public_path__ + "static/media/VaccineExercise – 1.db323052.jpg";